import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { BASE_URL } from "../../constants";
import Header from "../Helper/Header";
import NewFooter from "../Helper/NewFooter";
import ContactForm from "../../components/ContactForm/ContactForm";
const Agencies = () => {
  return (
    <>
      <Header />
      <Container fluid>
        {/* Heading 1 */}
        <Row className="justify-content-center">
          <Col className="text-center">
            <h1 className="heading1">Empowering</h1>
          </Col>
        </Row>

        {/* Heading 2 */}
        <Row className="justify-content-center">
          <Col className="text-center">
            <h2 className="heading2">
              Government <br />
              Agencies
            </h2>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col className="text-center">
            <h1 className="heading3">to drive Climate Action</h1>
          </Col>
        </Row>

        {/* First Grid */}
        <div>
          <Row className="justify-content-center align-items-end">
            {" "}
            {/* Add align-items-end here */}
            <Col md={4} className="left-box">
              <p>
                Government agencies play a crucial role in shaping climate
                policies, enforcing regulations, and supporting industries in
                the transition to Net Zero. However, achieving ambitious
                sustainability targets requires accurate forecasting, risk
                assessment, and data-driven decision-making. Dsider provides
                powerful simulation, carbon analysis, and financial modeling
                tools to help governments develop effective policies and
                implement impactful sustainability strategies.{" "}
              </p>
            </Col>
            <Col md={8} className="d-flex align-items-end">
              {" "}
              {/* Add d-flex and align-items-end here */}
              <img
                src={`${BASE_URL}solutions/government_agencies.png`}
                alt="Climate Tech"
                className="right-image"
              />
            </Col>
          </Row>
        </div>

        {/* Second Grid */}
        <div className="container " style={{ marginTop: "6rem" }}>
          <Row className="d-flex justify-content-center align-items-center">
            <Col md={4}>
              <img
                src={`${BASE_URL}solutions/digital_twin_ simulations.png`}
                alt="Power"
                className="power-image"
              />{" "}
            </Col>
            <Col md={8}>
              <h3 className="innovation-heading">
                Support Policy Development with Scenario Analysis{" "}
              </h3>
              <ul className="innovation-list">
                <li>
                  Model the effects of different climate policies before
                  implementation.{" "}
                </li>
                <li>
                  Compare emission reduction strategies across industries and
                  sectors.{" "}
                </li>
                <li>
                  Forecast long-term economic and environmental outcomes of
                  regulatory decisions.
                </li>
                {/* Add 2 more list items here */}
              </ul>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col md={4}>
              <img
                src={`${BASE_URL}solutions/carbon_footprint.png`}
                alt="Power"
                className="power-image"
              />{" "}
            </Col>
            <Col md={8}>
              <h3 className="innovation-heading">Track and Reduce Emissions</h3>
              <ul className="innovation-list">
                <li>
                  Monitor carbon emissions across industries, regions, and
                  sectors.
                </li>
                <li>
                  Evaluate the effectiveness of sustainability programs and
                  incentives.
                </li>
                <li>
                  Develop targeted strategies to meet climate commitments at
                  local, national, or global levels.
                </li>
                {/* Add 2 more list items here */}
              </ul>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col md={4}>
              <img
                src={`${BASE_URL}solutions/cost_benefit_ analysis.png`}
                alt="Power"
                className="power-image"
              />{" "}
            </Col>
            <Col md={8}>
              <h3 className="innovation-heading">
                Manage Financial and Climate Risks
              </h3>
              <ul className="innovation-list">
                <li>
                  Risk assessments for industries transitioning to low-carbon
                  operations.
                </li>
                <li>
                  Financial modeling to evaluate costs and benefits of
                  sustainability programs.
                </li>
                <li>
                  Data-driven insights to create resilience strategies for
                  climate adaptation.{" "}
                </li>
                {/* Add 2 more list items here */}
              </ul>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col md={4}>
              <img
                src={`${BASE_URL}solutions/complex_datasets.png`}
                alt="Power"
                className="power-image"
              />{" "}
            </Col>
            <Col md={8}>
              <h3 className="innovation-heading">
                Seamless Data Integration for Smarter Governance{" "}
              </h3>
              <ul className="innovation-list">
                <li>
                  Centralized access to real-time sustainability and economic
                  data.{" "}
                </li>
                <li>
                  AI-powered analytics for more informed decision-making.{" "}
                </li>
                <li>
                  Automated compliance tracking to align with evolving
                  environmental policies.
                </li>
                {/* Add 2 more list items here */}
              </ul>
            </Col>
          </Row>
        </div>

        {/* Action Box */}
        <Row className="justify-content-center">
          <Col
            className="action-box"
            style={{
              display: "grid",
              gridTemplateRows: "auto 1fr",
              alignItems: "start",
              justifyItems: "start",
            }}
          >
            <h4 className="action-heading">
              Powering Smarter,
              <br /> More Effective <br /> Climate Policies with
              <br /> Dsider{" "}
            </h4>
            <p
              className="action-textAgent"
              style={{ justifySelf: "end", alignSelf: "end" }}
            >
              Dsider equips government agencies with the tools to develop
              data-driven policies, track climate progress, and drive real
              impact. Whether you're working on carbon reduction programs,
              energy transition planning, or sustainable infrastructure, our
              platform provides the insights needed to create a greener, more
              resilient future.
            </p>
          </Col>
        </Row>
      </Container>
      <ContactForm showFooter={false}/>
      <NewFooter />
    </>
  );
};

export default Agencies;
